import { applyOverrides as applyRuleOverrides } from '@wix/form-conditions';
import { applyNestedFormOverrides } from '@wix/nested-form-overrides';
import { applyNestedForms } from '../../services';
import { applyFormOverrides } from '../../services/form-overrides';
export function applyAllOverrides(form, values, overrides) {
  return applyNestedForms(applyFormOverrides(applyNestedFormOverrides(applyRuleOverrides(form, values)), overrides ?? {}));
}
//# sourceMappingURL=all-overrides.js.map